import React, { SVGProps } from 'react';

const SvgTeachingEducationAndTraining = (props: SVGProps<SVGSVGElement>) => (
    <svg width={29.175} viewBox="0 0 29.175 29.487" {...props}>
        <g data-name="Teaching, Education and Training">
            <g data-name="Group 329">
                <g data-name="Group 326" transform="translate(.399 .446)">
                    <path
                        data-name="Path 1013"
                        d="M23.713 23.882H4.664a.748.748 0 0 1-.748-.748v-6.937a.748.748 0 0 1 .748-.748h19.049a.748.748 0 0 1 .748.748v6.937a.748.748 0 0 1-.748.748Z"
                        fill="#12b05e"
                    />
                    <path
                        data-name="Path 1014"
                        d="M23.713 15.444h-1.958a.748.748 0 0 1 .748.748v6.937a.748.748 0 0 1-.748.748h1.958a.748.748 0 0 0 .748-.748v-6.937a.748.748 0 0 0-.748-.748Z"
                        fill="#03984b"
                    />
                    <path
                        data-name="Path 1015"
                        d="M17.207 4.8h1.333V2.679A1.977 1.977 0 0 0 16.563.702h-.7v2.75A1.348 1.348 0 0 0 17.207 4.8Z"
                        fill="#a74b30"
                    />
                    <path
                        data-name="Path 1016"
                        d="M17.207 4.8h1.333V2.679A1.977 1.977 0 0 0 16.563.702h-.7v2.75A1.348 1.348 0 0 0 17.207 4.8Z"
                        fill="#a74b30"
                    />
                    <path
                        data-name="Path 1017"
                        d="M11.497 11.159h-.463a1.58 1.58 0 0 0-1.58 1.58v2.71h9.478v-2.706a1.58 1.58 0 0 0-1.58-1.58Z"
                        fill="#d5e3f4"
                    />
                    <path
                        data-name="Path 1018"
                        d="M14.183 12.603a1.459 1.459 0 0 1-1.459-1.459V8.116h2.92v3.029a1.459 1.459 0 0 1-1.461 1.458Z"
                        fill="#ffbfb1"
                    />
                    <path
                        data-name="Path 1019"
                        d="M17.703 4.798h-.049a3.521 3.521 0 0 0-6.943 0h-.049a1.2 1.2 0 0 0 0 2.391h.049a3.521 3.521 0 0 0 6.943 0h.049a1.2 1.2 0 1 0 0-2.391Z"
                        fill="#ffcebf"
                    />
                    <path
                        data-name="Path 1020"
                        d="M17.704 4.798h-.049a3.523 3.523 0 0 0-3.961-2.9 3.522 3.522 0 0 1 2.982 2.9h.049a1.2 1.2 0 1 1 0 2.391h-.049a3.523 3.523 0 0 1-2.982 2.9 3.523 3.523 0 0 0 3.961-2.9h.049a1.2 1.2 0 1 0 0-2.391Z"
                        fill="#ffbfb1"
                    />
                    <path
                        data-name="Path 1021"
                        d="M14.824 0h-5v3.215A1.585 1.585 0 0 0 11.409 4.8h3.92a1.49 1.49 0 0 0 1.49-1.49V1.995A2 2 0 0 0 14.824 0Z"
                        fill="#c4573a"
                    />
                    <path
                        data-name="Path 1022"
                        d="M14.821 0h-1.468a2 2 0 0 1 2 2v1.314a1.49 1.49 0 0 1-1.49 1.49h1.468a1.49 1.49 0 0 0 1.49-1.49V1.995a2 2 0 0 0-2-2Z"
                        fill="#a74b30"
                    />
                    <path
                        data-name="Path 1023"
                        d="M10.925 12.603h6.515v2.846h-6.515Z"
                        fill="#fff"
                    />
                    <circle
                        data-name="Ellipse 73"
                        cx={2.721}
                        cy={2.721}
                        r={2.721}
                        transform="translate(1.124 20.456)"
                        fill="#ffcebf"
                    />
                    <path
                        data-name="Path 1024"
                        d="M7.699 28.623h-7.7a2.73 2.73 0 0 1 2.73-2.73h2.24a2.73 2.73 0 0 1 2.73 2.73Z"
                        fill="#ffcd27"
                    />
                    <circle
                        data-name="Ellipse 74"
                        cx={2.721}
                        cy={2.721}
                        r={2.721}
                        transform="translate(11.565 20.456)"
                        fill="#ffcebf"
                    />
                    <path
                        data-name="Path 1025"
                        d="M18.14 28.623h-7.7a2.73 2.73 0 0 1 2.73-2.73h2.24a2.73 2.73 0 0 1 2.73 2.73Z"
                        fill="#ffcd27"
                    />
                    <circle
                        data-name="Ellipse 75"
                        cx={2.721}
                        cy={2.721}
                        r={2.721}
                        transform="translate(21.736 20.456)"
                        fill="#ffcebf"
                    />
                    <g data-name="Group 324" fill="#ffcd27">
                        <path
                            data-name="Path 1026"
                            d="M28.311 28.624h-7.7a2.73 2.73 0 0 1 2.73-2.73h2.24a2.73 2.73 0 0 1 2.73 2.73Z"
                        />
                        <path
                            data-name="Path 1027"
                            d="M14.707 18.674h-1.036a.777.777 0 1 1 0-1.554h1.036a.777.777 0 1 1 0 1.554Z"
                        />
                        <path
                            data-name="Path 1028"
                            d="M8.181 18.674H7.145a.777.777 0 0 1 0-1.554h1.036a.777.777 0 1 1 0 1.554Z"
                        />
                        <path
                            data-name="Path 1029"
                            d="M21.233 18.674h-1.038a.777.777 0 1 1 0-1.554h1.036a.777.777 0 0 1 0 1.554Z"
                        />
                    </g>
                    <g data-name="Group 325">
                        <path
                            data-name="Path 1030"
                            d="M17.441 11.162v4.287h1.486v-2.71a1.58 1.58 0 0 0-1.486-1.577Z"
                            fill="#b3dafe"
                        />
                    </g>
                    <path
                        data-name="Path 1031"
                        d="M3.846 20.456a2.723 2.723 0 0 0-.653.079 2.721 2.721 0 0 1 0 5.283 2.721 2.721 0 1 0 .653-5.363Z"
                        fill="#ffbfb1"
                    />
                    <path
                        data-name="Path 1032"
                        d="M4.969 25.893H3.664a2.73 2.73 0 0 1 2.73 2.73h1.304a2.73 2.73 0 0 0-2.729-2.73Z"
                        fill="#deaa00"
                    />
                    <path
                        data-name="Path 1033"
                        d="M14.287 20.456a2.723 2.723 0 0 0-.653.079 2.721 2.721 0 0 1 0 5.283 2.721 2.721 0 1 0 .653-5.363Z"
                        fill="#ffbfb1"
                    />
                    <path
                        data-name="Path 1034"
                        d="M15.41 25.893h-1.305a2.73 2.73 0 0 1 2.73 2.73h1.305a2.73 2.73 0 0 0-2.73-2.73Z"
                        fill="#deaa00"
                    />
                    <path
                        data-name="Path 1035"
                        d="M24.457 20.456a2.723 2.723 0 0 0-.653.079 2.721 2.721 0 0 1 0 5.283 2.721 2.721 0 1 0 .653-5.363Z"
                        fill="#ffbfb1"
                    />
                    <path
                        data-name="Path 1036"
                        d="M25.581 25.893h-1.305a2.73 2.73 0 0 1 2.73 2.73h1.305a2.73 2.73 0 0 0-2.73-2.73Z"
                        fill="#deaa00"
                    />
                </g>
                <g data-name="Group 327">
                    <path
                        data-name="Path 1037"
                        d="M17.097 8.19h-.487a.311.311 0 0 1 0-.621h.487a.311.311 0 0 1 0 .621Z"
                        fill="#ffb09e"
                    />
                </g>
                <g data-name="Group 328">
                    <path
                        data-name="Path 1038"
                        d="M12.553 8.19h-.487a.311.311 0 0 1 0-.621h.487a.311.311 0 0 1 0 .621Z"
                        fill="#ffb09e"
                    />
                </g>
            </g>
            <g data-name="Group 330">
                <path
                    data-name="Path 1039"
                    d="M13.329 7.005v-.648a.432.432 0 0 0-.864 0v.648a.432.432 0 1 0 .864 0Z"
                />
                <path
                    data-name="Path 1040"
                    d="M16.333 7.438a.432.432 0 0 0 .432-.432v-.648a.432.432 0 1 0-.864 0v.648a.432.432 0 0 0 .432.432Z"
                />
                <path
                    data-name="Path 1041"
                    d="M14.614 9.285a1.181 1.181 0 0 0 1.18-1.18.432.432 0 1 0-.864 0 .316.316 0 1 1-.631 0 .432.432 0 1 0-.864 0 1.181 1.181 0 0 0 1.179 1.18Z"
                />
                <path
                    data-name="Path 1042"
                    d="M26.912 26.024a3.151 3.151 0 0 0-1.587-5.538v-3.857a1.181 1.181 0 0 0-1.18-1.18h-4.357v-.381a.432.432 0 0 0-.864 0v.381h-.623v-2.414a.432.432 0 0 0-.432-.432v-.576a1.152 1.152 0 0 1 1.051 1.057.432.432 0 0 0 .862-.064 2.02 2.02 0 0 0-2.006-1.861h-1.271v-.649a3.932 3.932 0 0 0 1.937-2.486 1.626 1.626 0 0 0 .938-2.645.429.429 0 0 0 .026-.147V3.111A2.41 2.41 0 0 0 16.961.7a2.419 2.419 0 0 0-1.706-.7h-5a.432.432 0 0 0-.432.432v3.215a2.008 2.008 0 0 0 .512 1.34 1.627 1.627 0 0 0 .453 3.037 3.932 3.932 0 0 0 1.937 2.486v.649h-1.263a2.014 2.014 0 0 0-2.012 2.012v2.278H5.096a1.181 1.181 0 0 0-1.18 1.18v.681a.432.432 0 0 0 .864 0v-.681a.317.317 0 0 1 .316-.316h19.049a.317.317 0 0 1 .316.316v3.855a3.159 3.159 0 0 0-2.713 3.4h-3.889c.007-.081.012-.187.012-.274a3.153 3.153 0 1 0-6.306 0c0 .091.006.2.012.274H7.418a3.059 3.059 0 0 0 .005-.472A3.151 3.151 0 0 0 4.78 20.5v-1.17a.432.432 0 1 0-.864 0v1.151a3.151 3.151 0 0 0-1.66 5.549A3.167 3.167 0 0 0 0 29.059a.432.432 0 0 0 .432.432h7.7a.432.432 0 0 0 .432-.432 3.167 3.167 0 0 0-2.263-3.031 3.166 3.166 0 0 0 .916-1.278h4.561a3.166 3.166 0 0 0 .918 1.28 3.167 3.167 0 0 0-2.256 3.029.432.432 0 0 0 .432.432h7.7a.432.432 0 0 0 .432-.432 3.167 3.167 0 0 0-2.263-3.031 3.167 3.167 0 0 0 .916-1.278h4.291a3.166 3.166 0 0 0 .918 1.28 3.167 3.167 0 0 0-2.256 3.029.432.432 0 0 0 .432.432h7.7a.432.432 0 0 0 .432-.432 3.167 3.167 0 0 0-2.263-3.031Zm-10.46-14h.557v.58h-.808a1.877 1.877 0 0 0 .251-.581Zm2.091-8.912V4.8h-.108a3.948 3.948 0 0 0-.752-1.474 4.825 4.825 0 0 0-.119-1.648 1.547 1.547 0 0 1 .978 1.433ZM10.688.864h4.568a1.566 1.566 0 0 1 1.509 1.154 7.014 7.014 0 0 1 .055 1.723A1.06 1.06 0 0 1 15.76 4.8h-3.92a1.155 1.155 0 0 1-1.152-1.153V.864Zm.882 6.685a.432.432 0 0 0-.443-.36.763.763 0 1 1-.031-1.526.449.449 0 0 0 .265-.056 2.115 2.115 0 0 0 .481.058h3.92a1.93 1.93 0 0 0 1.705-1.035 3.075 3.075 0 0 1 .2.675.447.447 0 0 0 .5.361.763.763 0 1 1-.056 1.525.434.434 0 0 0-.443.36 3.078 3.078 0 0 1-3.045 2.575 3.079 3.079 0 0 1-3.046-2.575Zm3.046 3.439a4.037 4.037 0 0 0 1.027-.134v.724a1.027 1.027 0 0 1-2.053 0v-.724a4.03 4.03 0 0 0 1.025.133Zm-2.394 1.036h.557a1.881 1.881 0 0 0 .251.58h-.808v-.58Zm-1.907 1.148a1.149 1.149 0 0 1 1.043-1.143v.571a.432.432 0 0 0-.432.432v2.414h-.612Zm1.473 2.277v-1.982h5.652v1.982Zm-9.8 8.16a2.29 2.29 0 0 1 2.345-2.288 2.288 2.288 0 0 1 .076 4.572h-.267a2.292 2.292 0 0 1-2.154-2.284Zm3.413 3.149a2.3 2.3 0 0 1 2.257 1.866H.905a2.3 2.3 0 0 1 2.257-1.866Zm9.317-5.438a2.289 2.289 0 0 1 .136 4.574h-.271a2.289 2.289 0 0 1 .136-4.574Zm1.124 5.438a2.3 2.3 0 0 1 2.257 1.866h-6.754a2.3 2.3 0 0 1 2.257-1.866Zm11.336-3.149a2.292 2.292 0 0 1-2.153 2.285h-.271a2.292 2.292 0 0 1-2.132-1.974v-.027a2.289 2.289 0 1 1 4.56-.283Zm-5.662 5.014a2.3 2.3 0 0 1 2.257-1.866h2.24a2.3 2.3 0 0 1 2.257 1.866Z"
                />
                <path
                    data-name="Path 1043"
                    d="M15.138 19.538a1.209 1.209 0 1 0 0-2.418h-1.033a1.209 1.209 0 1 0 0 2.418Zm-1.381-1.209a.345.345 0 0 1 .345-.345h1.036a.345.345 0 0 1 0 .69h-1.033a.345.345 0 0 1-.348-.345Z"
                />
                <path
                    data-name="Path 1044"
                    d="M7.577 19.538h1.036a1.209 1.209 0 1 0 0-2.418H7.577a1.209 1.209 0 1 0 0 2.418Zm0-1.554h1.036a.345.345 0 1 1 0 .69H7.577a.345.345 0 1 1 0-.69Z"
                />
                <path
                    data-name="Path 1045"
                    d="M21.664 19.538a1.209 1.209 0 1 0 0-2.418h-1.036a1.209 1.209 0 1 0 0 2.418Zm-1.381-1.209a.345.345 0 0 1 .345-.345h1.036a.345.345 0 1 1 0 .69h-1.036a.345.345 0 0 1-.345-.345Z"
                />
            </g>
        </g>
    </svg>
);
export default SvgTeachingEducationAndTraining;
